<template>
    <!-- <span>{{ statusComponente }}</span> -->
    <div v-if="statusComponente != ''" class="flex items-center gap-2 px-2 rounded-md" :class="statusComponente?.classe">
        <div class="rounded-full p-1 animate-pulse"></div>
        <span class="text-xs">{{ statusComponente?.descricao }}</span>
    </div>
</template>

<script>
import StatusComponenteConstant from '@/constants/StatusComponenteConstant';
import { computed, defineComponent, ref, watch } from 'vue';

export default defineComponent({
    name: 'Status',
    props: {
        status: {
            type: String,
            required: true,
        }
    },
    setup(props) {
        const status = computed(() => props.status)
        const statusComponente = ref({})
        const statusPossiveis = {
            [StatusComponenteConstant.PREENCHIDO.chave]: {
                classe: StatusComponenteConstant.PREENCHIDO.chave,
                descricao: StatusComponenteConstant.PREENCHIDO.nome,
            },
            [StatusComponenteConstant.NAO_PREENCHIDO.chave]: {
                classe: StatusComponenteConstant.NAO_PREENCHIDO.chave,
                descricao: StatusComponenteConstant.NAO_PREENCHIDO.nome,
            },
            [StatusComponenteConstant.PENDENTE.chave]: {
                classe: StatusComponenteConstant.PENDENTE.chave,
                descricao: StatusComponenteConstant.PENDENTE.nome,
            }
        }

        statusComponente.value = status.value !== '' ? statusPossiveis[status.value] : ''

        watch(status, novoStatus => {
            statusComponente.value = statusPossiveis[novoStatus]
        })

        return { statusComponente }
    }
});
</script>

<style scoped>
.nao-preenchido {
    @apply bg-[#ffd5914d];
}

.nao-preenchido div {
    @apply bg-[#D46B08];
}

.nao-preenchido span {
    @apply text-[#D46B08];
}

.preenchido {
    @apply bg-[#b7eb8f4d];
}

.preenchido div {
    @apply bg-[#47A817];
}

.preenchido span {
    @apply text-[#47A817];
}

.pendente {
    @apply bg-[#ff8a8a4d];
}

.pendente div {
    @apply bg-[#FF0000];
}

.pendente span {
    @apply text-[#FF0000];
}
</style>
